import React, { FC, useState } from 'react';
import { SCUIButton, SCUINoRecordComponent, SCUILoadingLinear } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb } from '../../atomic/molecules';
import ImageSearchSvg from '../../assets/icons/svg/pageIcons/imageSearch.svg';
import cargoGif from '../../assets/gifs/cargo.gif';
import ViewListIcon from '@mui/icons-material/ViewList';

import Dialog from '@mui/material/Dialog';
import {
    Grid,
    Box,
    FormControl,
    Paper,
    InputBase,
    Button,
    ImageList,
    ImageListItem,
    Checkbox,
    styled,
    FormControlLabel,
} from '@mui/material';
import { ImageSearchServiceQuery } from '../../services/query/';
import { SCUIImageBatchSearchModal, SCUIProductList } from './components';
import { SCUIDownloadImageComponent } from '../../atomic/atoms/SCUIDownloadImageComponent/SCUIDownloadImageComponent';
import GridViewIcon from '@mui/icons-material/GridView';
import { IMGSEARCH, imgSearchCls } from './imageSearch.classes';
import { formatNotFoundRecords, parseImageSearchResponseData } from './ImageSearch.helper';
interface DataItem {
    img: string;
    title: string;
}

export const ImageSearch: FC<any> = (props: any) => {
    const [searchedText, setSearchedText] = useState('');

    const { t } = useTranslation();
    const [listModalOpen, setListModalOpen] = useState(false);
    const [datas, setDatas] = React.useState<any>();
    const [notFoundRecords, setNotFoundRecords] = React.useState<any>();
    const [loading, setLoading] = React.useState(false);
    const [downloadLoading, setDownloadLoading] = React.useState(false);
    const [checkboxStatus, setCheckboxStatus] = React.useState(false);
    const [checkBoxTitle, setCheckboxTitle] = React.useState('Tümünü Seç');
    const [selectedItems, setSelectedItems] = useState<DataItem[]>([]);
    const [view, setView] = useState('list');

    const handleCloseModal = () => {
        setListModalOpen(false);
    };

    const handleImageClick = (item: any) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter((i) => i !== item));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };
    const handleSelectClick = (item: boolean) => {
        setCheckboxStatus(item);
        setCheckboxTitle(item ? 'Tümünü Kaldır' : 'Tümünü Seç');
        if (item) {
            setSelectedItems([...selectedItems, ...datas.map((item: any) => item)]);
        } else {
            setSelectedItems([]);
        }
    };
    const handleListViewClick = () => {
        setView('list');
    };

    const handleGridViewClick = () => {
        setView('grid');
    };
    const BATCH_SEARCH_LIMIT = 15;

    const listele = async () => {
        const codes = searchedText
            .trim()
            .split('\n')
            .filter((line: string) => line.trim() !== '');
        if (codes.length > BATCH_SEARCH_LIMIT) {
            Swal.fire(
                t('general.warning'),
                t('imageSearch.batchSearchLimitWarning', { max: BATCH_SEARCH_LIMIT, count: codes.length }),
                'warning'
            );
            return;
        }
        setLoading(true);
        setDatas('');
        setNotFoundRecords('');
        setSelectedItems([]);
        let obj = {
            specialCode: codes,
        };
        ImageSearchServiceQuery.GetImageData(obj)
            .then((res: any) => {
                if (res) {
                    const validData = parseImageSearchResponseData(res.data);

                    if (validData.length === 0) {
                        Swal.fire(t('general.noDataFound'), t('imageSearch.noPhotosFound'), 'error');
                        setLoading(false);
                        return;
                    }

                    setDatas(validData);

                    if (res.notFoundRecords && res.notFoundRecords.length > 0) {
                        setNotFoundRecords(formatNotFoundRecords(res.notFoundRecords));
                    }
                } else {
                    Swal.fire(t('general.noDataFound'), ' ', 'error');
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const StyledViewListIcon = styled(ViewListIcon)({
        fontSize: '3rem',
        color: 'deepskyblue',
        cursor: 'pointer',
    });
    const StyledGridViewIcon = styled(GridViewIcon)({
        fontSize: '3rem',
        color: 'deepskyblue',
        cursor: 'pointer',
    });

    const GetImages = async () => {
        setLoading(true);
        setDatas('');
        setNotFoundRecords('');
        setSelectedItems([]);
        let obj = {
            specialCode: searchedText.trim().split('\n'),
        };
        ImageSearchServiceQuery.GetImageData(obj)
            .then((res: any) => {
                if (res.data.length > 0) {
                    const validData = parseImageSearchResponseData(res.data);

                    if (validData.length === 0) {
                        Swal.fire(t('general.noDataFound'), t('imageSearch.noPhotosFound'), 'error');
                        setLoading(false);
                        return;
                    }

                    setDatas(validData);
                } else {
                    Swal.fire(t('general.noDataFound'), ' ', 'error');
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <SCUIContent>
            <Box className={IMGSEARCH.page}>
            <Grid
                size={{
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Grid className={IMGSEARCH.breadcrumbRow} container direction="row" spacing={2} sx={{ marginLeft: '0.5rem' }}>
                    <div className={IMGSEARCH.breadcrumbSection}>
                    <SCUIBreadCrumb
                        title={'Görsel Arama'}
                        componentLink={'/ImageSearch'}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            setDatas('');
                            setSearchedText('');
                            setNotFoundRecords('');
                        }}
                    />
                    </div>
                    <div className={IMGSEARCH.loadingSection}>
                    <SCUILoadingLinear display={loading} />
                    </div>
                    <Dialog
                        open={downloadLoading && selectedItems.length > 0}
                        sx={{
                            backdropFilter: 'blur(3px) sepia(5%)',
                        }}
                        slotProps={{
                            paper: {
                                className: IMGSEARCH.downloadOverlayDialogPaper,
                                sx: { borderRadius: '5rem' },
                            },
                        }}
                    >
                        <Grid>
                            <ImageList style={{ gridTemplateColumns: 'auto' }}>
                                <img src={cargoGif} alt="" />
                            </ImageList>
                        </Grid>
                    </Dialog>
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Grid
                        sx={{ marginTop: '20px' }}
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        {datas && datas.length > 0 ? (
                            <Grid container>
                                <Grid container justifyContent="flex-end" className={IMGSEARCH.resultsToolbar}>
                                    <FormControlLabel
                                        className={IMGSEARCH.labelSelectAllWrap}
                                        label={checkBoxTitle}
                                        control={
                                            <Checkbox
                                                className={IMGSEARCH.inputCheckboxSelectAll}
                                                checked={checkboxStatus}
                                                onChange={() => handleSelectClick(!checkboxStatus)}
                                                title={checkBoxTitle}
                                            />
                                        }
                                    />

                                    <Box className={IMGSEARCH.inputIconListView} onClick={handleListViewClick} sx={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <StyledViewListIcon
                                        sx={{ marginRight: '16px', cursor: 'pointer' }}
                                    />
                                    </Box>
                                    <Box className={IMGSEARCH.inputIconGridView} onClick={handleGridViewClick} sx={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <StyledGridViewIcon
                                        sx={{ marginRight: '16px', cursor: 'pointer' }}
                                    />
                                    </Box>
                                    <Box className={IMGSEARCH.downloadWrap}>
                                    <SCUIDownloadImageComponent
                                        selectedItems={selectedItems}
                                        downloadLoading={downloadLoading}
                                        setDownloadLoading={setDownloadLoading}
                                    />
                                    </Box>
                                </Grid>
                                <Grid
                                    className={IMGSEARCH.resultsSummary}
                                    size={{
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <p>
                                        <strong>Arama Sonuçları: </strong>Toplam <strong>{datas.length} sonuç</strong>{' '}
                                        bulundu.
                                        <p
                                            className={IMGSEARCH.notFoundHint}
                                            style={{
                                                color: 'gray',
                                                fontStyle: 'italic',
                                                fontSize: '12px',
                                            }}
                                        >
                                            {' '}
                                            {notFoundRecords && 'Sonuç bulunamadı: ' + notFoundRecords.join(', ')}
                                        </p>
                                    </p>
                                </Grid>
                                {view === 'grid' ? (
                                    <Grid
                                        size={{
                                            sm: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12,
                                        }}
                                    >
                                        <ImageList
                                            className={IMGSEARCH.gridImageList}
                                            sx={{
                                                height: 500,
                                                marginBottom: '20px',
                                                overflow: 'visible',
                                            }}
                                            cols={5}
                                            rowHeight={400}
                                        >
                                            {datas.map((item: any) => (
                                                <ImageListItem
                                                    className={IMGSEARCH.gridImageListItem}
                                                    key={item.imagePathIndexMetas.uri}
                                                    sx={{
                                                        position: 'relative',
                                                        // boxShadow: selectedItems.includes(item)
                                                        //   ? "0px 0px 5px 2px rgba(0, 0, 255, 0.5)"
                                                        //   : "none",
                                                        borderRadius: '10px',
                                                        zIndex: 2,
                                                    }}
                                                    onClick={() => handleImageClick(item)}
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <div
                                                        className={IMGSEARCH.gridImageOverlay}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                            // backgroundColor: selectedItems.includes(item)
                                                            //   ? "rgba(0, 0, 255, 0.2)" // Seçildiğinde arka plan rengi
                                                            //   : "transparent", // Seçilmediğinde arka plan rengi
                                                            borderRadius: '10px',
                                                            transition: 'background-color 0.3s ease',
                                                        }}
                                                    ></div>
                                                    <img
                                                        className={IMGSEARCH.gridProductImage}
                                                        src={`${item.imagePathIndexMetas.uri}?w=750&h=800&fit=crop&auto=format`}
                                                        srcSet={`${item.imagePathIndexMetas.uri}?w=750&h=800&fit=crop&auto=format&dpr=2 2x`}
                                                        alt={item.title}
                                                        loading="lazy"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            // objectFit: "contain",
                                                            borderRadius: '10px',
                                                        }}
                                                    />
                                                    <Checkbox
                                                        className={IMGSEARCH.inputCheckboxGridItem}
                                                        checked={selectedItems.includes(item)}
                                                        onChange={() => handleImageClick(item)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 10,
                                                            right: 10,
                                                            zIndex: 1,
                                                            paddingTop: 6,
                                                            transform: 'scale(2)',
                                                        }}
                                                    />
                                                </ImageListItem>
                                            ))}
                                        </ImageList>
                                    </Grid>
                                ) : (
                                    <SCUIProductList
                                        products={datas}
                                        selectedItems={selectedItems}
                                        setSelectedItems={setSelectedItems}
                                    ></SCUIProductList>
                                )}
                            </Grid>
                        ) : (
                            <div
                                className={IMGSEARCH.emptyStateWrap}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignContent: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <SCUINoRecordComponent
                                    img={ImageSearchSvg}
                                    text={t('general.imageSearchNoRecordText')}
                                />
                                <div className={IMGSEARCH.searchPaperWrap} style={{ marginTop: '2rem' }}>
                                    <Paper className={imgSearchCls(IMGSEARCH.searchPaper, 'textFieldWithButtonPaper textButtonSelect')}>
                                        <InputBase
                                            className={IMGSEARCH.inputSearchCodes}
                                            sx={{ ml: 1, flex: 1, fontSize: '1.6rem' }}
                                            fullWidth
                                            placeholder={t('searchService.specialAndColorCode')}
                                            onChange={(e) => setSearchedText(e.target.value)}
                                            onKeyDown={props.onKeyPressTextField}
                                        />
                                        <Button
                                            className={imgSearchCls(IMGSEARCH.inputButtonSearch, 'textFieldWithButton')}
                                            color="primary"
                                            type="button"
                                            onClick={GetImages}
                                        >
                                            {t('general.search')}
                                        </Button>
                                    </Paper>
                                </div>
                                <FormControl className={IMGSEARCH.batchSearchFormWrap} style={{ width: 500, marginRight: '10px', marginTop: '3rem' }}>
                                    <SCUIButton
                                        className={IMGSEARCH.inputButtonBatchSearch}
                                        text={t('general.batchSearch')}
                                        type="secondary"
                                        sizeType="fixed"
                                        size={'l'}
                                        onClick={() => {
                                            setListModalOpen(true);
                                        }}
                                    />
                                    <SCUIImageBatchSearchModal
                                        open={listModalOpen}
                                        onClose={handleCloseModal}
                                        searchedText={searchedText}
                                        setSearchedText={setSearchedText}
                                        listele={listele}
                                        text={t('searchService.specialAndColorCode')}
                                    />
                                </FormControl>
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            </Box>
        </SCUIContent>
    );
};
